export const formatAbn = (raw: string): string => {
  if (!raw) {
    return raw;
  }

  const trimmed = raw.replace(/ /g, '');

  // ABN - ## ### ### ###
  if (trimmed.length === 11) {
    return `${trimmed.substring(0, 2)} ${trimmed.substring(2, 5)} ${trimmed.substring(5, 8)} ${trimmed.substring(8)}`;
  }

  return raw;
};

export const formatMobileNumber = (raw: string): string => {
  if (!raw) {
    return '';
  }

  if (raw.startsWith('4')) {
    return `+61${raw}`;
  }

  if (raw.startsWith('0')) {
    return `+61${raw.substring(1)}`;
  }

  return raw;
};

export const formatSupplierTerm = (term: number, termPeriod: string): string => {
  if (term === 0) {
    return 'COD';
  }

  if (term === 1) {
    return `${term} day`;
  }

  if (termPeriod === 'EOM') {
    return `${term} days EOM`;
  }

  return `${term} days`;
};

export default {
  formatAbn,
  formatMobileNumber,
  formatSupplierTerm,
};
